module.exports = __webpack_public_path__ + "static/media/casa-riviere-banner.76a77105.webp";